<template>
	<div class="toggle">
		<p class="toggle__label">{{labels[0]}}</p>
		<div class="toggle__box" @click="toggle">
			<div class="toggle__box__dot" :class="{'toggle__box__dot--right': activeIndex === 1}"></div>
		</div>
		<p class="toggle__label">{{labels[1]}}</p>
	</div>
</template>

<script>
export default {
	props: {
		options: Array,
		labels: Array,
		value: null
	},
	data () {
		return {
		}
	},
	methods: {
		toggle () {
			const newValue = (this.activeIndex === 0) ? this.options[1] : this.options[0]
			this.$emit('input', newValue)
			this.$emit('change')
		}
	},
	computed: {
		activeIndex () {
			return this.options.findIndex(option => option === this.value)
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_toggle.scss";
</style>
